import classnames from 'classnames';
import React from 'react';

interface BadgeProps {
    className?: string,
    label: string,
}

/**
 * Generic badge component that displays values in a colored bubble, commonly called a 'badge' in UX.
 * 
 * @param {object} props 
 */
function Badge(props: BadgeProps) {

    const className = classnames('badge', props.className);

    return (
        <span className={className}>{props.label}</span>
    );

}

export default Badge;